module.exports = __webpack_public_path__ + "img/thumb_2019-02.d57b24a3.jpg";